import React from "react";
import { _LandingMenuRoot } from "../LandingMenu.styled";
import Typography from "../../../../Foundation/Typography/Typography";
import GradientButton from "../../../../Foundation/Button/GradientButton";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import clsx from "clsx";

interface IMenuAdrienCachotProps {
  title?: string;
  linkText?: string;
  onClick?: () => void;
  className?: string;
}

const MenuAdrienCachot = (props: IMenuAdrienCachotProps) => {
  const { title, linkText, onClick, className } = props;

  return (
    <_LandingMenuRoot
      className={clsx("landing-menu landing-menu__menu", className)}
    >
      <StyledDiv
        styles={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "flex-start",
          maxWidth: "664px",
          width: "100%",
          margin: "0 auto",
          gap: 24,
          mobile: {
            maxWidth: "256px",
            margin: "0",
          },
        }}
      >
        <Typography align="left" variant="adriencachot3">
          {title}
        </Typography>

        <div>
          <GradientButton onClick={onClick} textTransform="uppercase">
            {linkText}
          </GradientButton>
        </div>
      </StyledDiv>
    </_LandingMenuRoot>
  );
};

export default MenuAdrienCachot;
